import router from './../router/index'
import store from './../store/index'

import utils from './utils'

/**
 *
 * @param {*} path
 * @param {RequestInit} options
 * @returns
 */
async function apiFetch(path, options) {
  console.log('[alex][apiFetch] start')
  //const token = localStorage.token

  const token = store.state.token

  const url = 'https://hslssqwjknieeziec7ha7yo3fy0butak.lambda-url.eu-west-3.on.aws' + path

  if (!options) options = { headers: {} }
  if (!options.headers) options.headers = {}
  //options.mode = 'no-cors'
  if (token) {
    options.headers['xvi-token'] = token
  }

  const x = await fetch(url, options)

  if (x.status == 403) {
    localStorage.token = ''
    if (router.currentRoute.path != '/auth') router.push('/auth?redirect=' + router.currentRoute.path)
  }
  return x
}

function username() {
  const token = store.state.token
  if (!token) return null
  return token.split('::')[0]
}

/**
 *
 * @param {File} file
 * @param {string} folder
 * @param {string} fileName
 * @returns
 */
async function uploadFile(file, folder, fileName) {
  const presignResponse = await apiFetch('/uploadfile', {
    method: 'POST',
    body: JSON.stringify({
      folder: folder,
      fileName,
      fileType: file.type,
    }),
  })

  const { uploadUrl, key, viewUrl } = await presignResponse.json()

  console.log('url', uploadUrl)
  console.log('key', key)

  // Upload to S3
  const uploadResponse = await fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
    },
  })

  if (uploadResponse.ok) {
    return { key, viewUrl }
  } else {
    return { key: null, viewUrl: null }
  }
}

/**
 *
 * @returns
 */
function userAppRoutes() {
  let profileMenuText = username() ? 'Usuario: ' + username() : 'Log in'

  let x = [{ name: profileMenuText, to: '/auth', icon: 'mdi-account', subtitle: '', shared: '' }]

  if (profileMenuText != 'Log in') {
    x.push({ name: 'Home', to: '/', icon: 'mdi-home', shared: '' })
    x.push({
      name: 'Listas',
      to: '/share-asins',
      icon: 'mdi-share',
      shared: 'family',
    })

    x.push({ name: 'Baby Tracker', to: '/baby-tracker', icon: 'mdi-baby-carriage', shared: 'couple' })
    x.push({ name: 'Gastos', to: '/expenses', icon: 'mdi-currency-usd', shared: 'couple' })

    x.push({ name: 'Groceries', to: '/groceries', icon: 'mdi-cart-variant', shared: 'couple' })
    x.push({ name: 'Menús', to: '/food/menus', icon: 'mdi-food', shared: 'family' })
    x.push({ name: 'Quotes', to: '/quotes', icon: 'mdi-format-quote-close', shared: 'personal' })
    x.push({ name: 'Tasks', to: '/todos', icon: 'mdi-calendar-check', shared: 'personal' })
    x.push({ name: 'Calendario', to: '/gcalendar', icon: 'mdi-calendar', shared: 'couple' })
    x.push({ name: 'Dieta', to: '/diabetes', icon: 'mdi-food-apple', shared: 'personal' })
    x.push({ name: 'UploadFile', to: '/uploadfile', icon: 'mdi-cloud-upload-outline', shared: 'personal' })
    x.push({ name: 'Películas', to: '/watchlist', icon: 'mdi-video-vintage', shared: 'family' })
    x.push({ name: 'Friends', to: '/friends', icon: 'mdi-ambulance', shared: 'personal' })
    x.push({ name: 'Facturas', to: '/facturas', icon: 'mdi-invoice', shared: 'personal' })

    //pregnancy
    const labor_due = new Date('2024-12-31')
    const labor_start = new Date(labor_due.getTime() - 280 * 24 * 60 * 60 * 1000) // Assuming pregnancy lasts 280 days
    const labor_week = utils.dates.diffToday(labor_start, ['weeks', 'days'])
    if (labor_week < 42) {
      x.push({
        name: 'Embarazo',
        to: '/embarazo',
        icon: 'mdi-human-pregnant',
        subtitle: labor_week.weeks + 'w ' + labor_week.days + 'd',
        shared: 'couple',
      })
    }
    x.push({ name: 'Ajustes', to: '/settings', icon: 'mdi-cog', shared: 'personal' })

    x.push({ name: 'Code', to: '/code', icon: 'mdi-code-tags', shared: 'n/a' })
    x.push({ name: 'Paraguas', to: '/paraguas', icon: 'mdi-umbrella', subtitle: '', shared: 'n/a' })
    x.push({ name: 'Text', to: '/text', icon: 'mdi-pencil', shared: 'n/a' })
    x.push({ name: 'Scan', to: '/barcode', icon: 'mdi-qrcode', shared: 'n/a' })
    x.push({ name: 'Privacidad', to: '/privacidad', icon: 'mdi-shield', subtitle: '', shared: 'n/a' })

    x.push({ name: 'Regalos', to: '/regalos', icon: 'mdi-gift', shared: 'family' })
  }
  return x
}

export default { apiFetch, uploadFile, userAppRoutes }
